import React from "react";
import { Breadcrumb } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleBreadcrumbProps extends React.ComponentProps<typeof Breadcrumb> {
  useEditorTheme?: boolean;
}

const TrebbleBreadcrumb = ({ useEditorTheme, ...restProps }: TrebbleBreadcrumbProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Breadcrumb {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleBreadcrumb;
